// extracted by mini-css-extract-plugin
export default {"root":"ModifyList_root__x7ORF","num":"ModifyList_num__3BppR","list":"ModifyList_list__xycEf","placeHolderShimmer":"ModifyList_placeHolderShimmer__pHOfG"};